import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { getActiveDirectoryList } from './service/active-directory.service';
import { SettingsIntegrationsActiveDirectoryListComponent } from './components';
import type { ActiveDirectoryListItem } from './components/settings-integrations-active-directory-list';
import { MAX_DIRECTORIES } from './settings-integrations-active-directory.constants';

export const SettingsAdminActiveDirectoryListContainer: React.FC = () => {
    const navigate = useNavigate();
    const [directories, setDirectories] = useState<ActiveDirectoryListItem[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    const handleClickRow = (id: string) => {
        navigate(id);
    };

    const handleAddDirectory = () => {
        navigate('new');
    };

    useEffect(() => {
        getActiveDirectoryList()
            .then((items) => {
                setDirectories(items);
            })
            .finally(() => setLoading(false));
    }, []);

    const isLimitReached = directories.length >= MAX_DIRECTORIES;
    const isAddDisabled = isLimitReached || loading;

    return (
        <SettingsIntegrationsActiveDirectoryListComponent
            directories={directories}
            loading={loading}
            isAddDisabled={isAddDisabled}
            isLimitReached={isLimitReached}
            onClickRow={handleClickRow}
            onAddDirectory={handleAddDirectory}
        />
    );
};
